import { render, staticRenderFns } from "./ToothImage.vue?vue&type=template&id=d92cbc3c&scoped=true&"
import script from "./ToothImage.vue?vue&type=script&lang=js&"
export * from "./ToothImage.vue?vue&type=script&lang=js&"
import style0 from "./ToothImage.vue?vue&type=style&index=0&id=d92cbc3c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92cbc3c",
  null
  
)

export default component.exports